"use strict";

module.exports = {
  'name': 'erf',
  'category': 'Special',
  'syntax': ['erf(x)'],
  'description': 'Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x',
  'examples': ['erf(0.2)', 'erf(-0.5)', 'erf(4)'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/special/erf.js
// module id = 941
// module chunks = 0